import { Component, forwardRef, Input, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { takeUntil } from 'rxjs';
import { UsersService } from 'src/app/shared/api-services/users.service';
import { UserModel } from 'src/app/shared/models/user/users';
import { BaseAutocompleteComponent } from '../base-autocomplete/base-autocomplete.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'user-autocomplete',
  imports: [
    TranslateModule,
    AutoCompleteModule,
    CommonModule,
    FormsModule
  ],
  template: `
    <p-autoComplete
      class="w-100"
      [placeholder]="placeholder | translate"
      [(ngModel)]="selectedItem"
      [showClear]="true"
      [forceSelection]="true"
      [suggestions]="listItems"
      (completeMethod)="getItems($event.query)"
      (onClear)="onClearItem()"
      (onSelect)="onSelectItem($event)"
      (onBlur)="onInputBlur()"
      [ngClass]="{'has-value': hasValue}"
      field="name">
    </p-autoComplete>
  `,
  styleUrls: ['../base-autocomplete/base-autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UserAutocompleteComponent),
      multi: true
    }
  ],
  standalone: true
})
export class UserAutocompleteComponent extends BaseAutocompleteComponent<UserModel, void> implements OnInit, OnChanges {
  @Input() initialUser: UserModel | null = null;

  constructor(private _usersService: UsersService) {
    super();
  }

  ngOnInit(): void {
    if (this.initialUser) {
      this.setInitialUser(this.initialUser);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['initialUser'] && this.initialUser) {
      this.setInitialUser(this.initialUser);
    }
  }

  private setInitialUser(user: UserModel): void {
    const userItem = { name: user.displayName || '', item: user };
    this.selectedItem = userItem;
    this.value = userItem.name;
    this.hasValue = true;
    this.listItems = [userItem];
    setTimeout(() => {
      this.onChange(user);
      this.onSelectedItem.emit(user);
    }, 0);
  }

  override writeValue(user: UserModel): void {
    if (user) {
      this.setInitialUser(user);
    } else {
      super.writeValue(null);
    }
  }

  override getItems(query: string): void {
    this._usersService.listUsers$({ 
      displayNameContains: query, 
      limit: this.limit 
    })
      .pipe(takeUntil(this._destroy$))
      .subscribe((response) => {
        this.listItems = response.items.map((user) => ({ name: user.displayName || '', item: user }));
      });
  }
} 